import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, Attribute, ViewChild, ElementRef, Renderer2
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef, MatSnackBar
} from '@angular/material';


@Component({
  selector: 'app-file-viewer-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'file-viewer-dialog.template.html'
})

export class FileViewerDialogComponent implements OnInit {
  @ViewChild('content', { static: true }) content: ElementRef;

  constructor(public dialogRef: MatDialogRef<FileViewerDialogComponent>,
              private renderer:Renderer2,
              @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  public ngOnInit(): void {
    this.parse();
  }

  public generateContent(node:any): any {
    let container = this.renderer.createElement('ul');
    if( Array.isArray(node) ) {
      node.map( (leaf) => {
        let item = this.renderer.createElement('li');
        if (["number", "string", "boolean"].includes(typeof leaf)) {
          item.appendChild(this.renderer.createText(`${leaf}`));
        } else if (typeof leaf === "object") {
          item.appendChild(this.generateContent(leaf));
        }
        container.appendChild(item);
      });
    } else {
      Object.keys(node).map((key) => {
        let item = this.renderer.createElement('li');
        let title = this.renderer.createElement('span');
        title.innerHTML = key.replace(/_/g, " ");
        item.appendChild(title);
        if (["number", "string", "boolean"].includes(typeof node[key])) {
          item.appendChild(this.renderer.createText(`: ${node[key]}`));
        } else if (typeof node[key] === "object") {
          item.appendChild(this.generateContent(node[key]));
        }
        container.appendChild(item);
      });
    }
    return container;
  }

  public parse(): void {
    let element = this.generateContent(this.data);
    this.content.nativeElement.appendChild(element);
  }

  public cancel() {
    this.dialogRef.close();
  }
}
